/* eslint-disable @typescript-eslint/member-ordering */
import { Injectable } from '@angular/core';
import { ConnectionStatus, Network } from '@capacitor/network';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  netStatus = new Subject<ConnectionStatus>();
  public cstatus: ConnectionStatus = null;
  constructor() {
    Network.getStatus().then((status) => {
      this.netStatus.next(status);
      this.cstatus = status;
    });
    Network.addListener('networkStatusChange', (status: ConnectionStatus) => {
      this.netStatus.next(status);
    });
  }

}
